

import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { Toast } from 'devextreme-react/toast';

const Toastr = forwardRef((props, ref) => {

    const [isVisible, setIsVisible] = useState(false);
    const [type, setType] = useState("error");
    const [message, setMessage] = useState("message");

    useImperativeHandle(ref, () => ({       
            setMessage, setType, show
    }));

    const show = () => {
        setIsVisible(true);
    };

    const hide = () => {
        setIsVisible(false);
    };

    return (
        <div>
            <Toast
                visible={isVisible}
                message={message}
                type={type}
                onHiding={hide}
                height={55}
                width={300}
                position={{ at: 'top center', my: 'top center', offset: '0 20' }}
            />
        </div>
    );

});

export default Toastr;
